import * as moment from 'moment'
export const dateMixin = {
  methods: {
    dateFromNow (date) {
      return moment(date).locale(this.$i18n.locale).fromNow()
    },
    dateFormat (date) {
      return moment(date).locale(this.$i18n.locale).format('dddd, MMMM Do YYYY')
    },
    formatDate (date) {
      return moment(date).format('LL')
    },
    dayMonthDateFormat (date) {
      return moment(date).locale(this.$i18n.locale).format('D MMMM')
    },
    simpleDateFormat (date) {
      return moment(date).locale(this.$i18n.locale).calendar()
    }
  }
}
